import FormGenerator from '../form/FormGenerator'
import { FormRow } from '../../../generated-types/form-field'
import { useCustomerCtx } from '../../../hooks/context-hooks'
import { IFormSchemaGeneric, SchemaType } from '../../../generated-types/form-schema'
import { useNavigate, useParams } from 'react-router-dom'
import { AppRoutesNavigation } from '../../../app-routes'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useGetFormSchemaById, useUpdateFormSchema, invalidateSchemaForm } from '../../../api/form-schema'

const EditChecklistTemplate = () => {
  const { customer } = useCustomerCtx()
  const { checklistTemplateId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation(['common', 'checklist'])
  const { data } = useGetFormSchemaById(customer.id, parseInt(checklistTemplateId || ''))
  const updateFormSchema = useUpdateFormSchema(customer.id, parseInt(checklistTemplateId || ''))

  return (
    <FormGenerator
      schemaType={SchemaType.Checklist}
      isEdit={true}
      onCancel={() => {
        navigate(AppRoutesNavigation.Customer.checklistTemplates(customer?.id))
      }}
      initialData={data}
      buttonTitle={t('update')}
      onSubmit={async (value: FormRow[], details: IFormSchemaGeneric) => {
        const checklistTemplate = {
          id: parseInt(checklistTemplateId || ''),
          name: details.name,
          description: details.description,
          hasVideoUpload: details.hasVideoUpload,
          isActive: details.isActive,
          schemaType: details.schemaType ?? SchemaType.Checklist,
          customerId: customer.id,
          versions: [
            {
              layout: JSON.stringify(value),
              version: (data?.version || 0) + 1,
            },
          ],
        }

        await updateFormSchema.mutateAsync(checklistTemplate, {
          onSuccess: () => {
            invalidateSchemaForm.getAllFormSchema(customer.id)
            invalidateSchemaForm.getSchemaById(customer.id, parseInt(checklistTemplateId || ''))
            invalidateSchemaForm.getFormSchemasForMovement(customer.id)
            toast.success(t('checklist-updated-successfully', { ns: 'checklist' }))
            navigate(AppRoutesNavigation.Customer.checklistTemplates(customer?.id))
          },
          onError: () => {
            toast.error(t('InternalError', { ns: 'common-api-message' }))
          },
        })
      }}
    />
  )
}

export default EditChecklistTemplate
